export default __webpack_public_path__ + "static/media/house-fill.672c9a9e.svg";